import {
    EMAIL_CREATE,
    EMAIL_LIST,
    EMAIL_UPDATE
} from "../actions";

export function email(currentState = {}, action) {
    switch (action.type) {
        case EMAIL_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case EMAIL_LIST:
            return currentState = action
        case EMAIL_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}